import DOMPurify from 'dompurify';

/**
 * Get a URL query string from a URL value.
 * @param {string} url A URL value.
 * @returns The URL query string value.
 */
function getQueryString(url = window.location.href) {
    const urlParts = DOMPurify.sanitize(url).split('?');
    return urlParts.length > 1 ? urlParts[1] : '';
}

/**
 * Get all URL parameters from a URL value.
 * @param {string} url A URL value.
 * @returns An array of URL parameter key/value pairs.
 */
function getParameters(url = window.location.href) {
    const queryString = getQueryString(url);
    return queryString.length
        ? queryString.split('&').map((param) => {
              return param.split('=');
          })
        : [];
}

/**
 * Get a specific URL parameter from a URL value.
 * @param {string} keyName A URL parameter key name.
 * @param {string} url A URL value.
 * @returns A URL parameter key/value pair.
 */
function getParameter(keyName, url = window.location.href) {
    let reqParam = {
        key: null,
        value: null
    };

    const params = getParameters(url);
    if (params.length) {
        params.forEach((param) => {
            const key = param[0];
            const value = param[1];

            if (key.toLowerCase() === keyName.toLowerCase()) {
                reqParam = {
                    key,
                    value
                };
            }
        });
    }

    return reqParam;
}

export { getQueryString, getParameters, getParameter };
